import { haloSessionTos } from "../../queries";
import { GET_USER_TOS_SESSION_INFO, GET_USER_TOS_SESSION_INFO_SUCCESS, GET_USER_TOS_SESSION_INFO_FAILURE } from "../constants";
import { API, graphqlOperation } from 'aws-amplify';

const getTosSessionInfo = (UserId: string, eventType: string) => {
  return async (dispatch: any) => {
    dispatch({ type: GET_USER_TOS_SESSION_INFO });
    try {
      if(UserId && eventType){
        const tosResponse = API.graphql(graphqlOperation(haloSessionTos, {UserId, eventType})) as Promise<any>;
      await tosResponse.then((tosSession: any) => {
        if(tosSession.data){
          const data = JSON.parse(tosSession.data.haloSessionTos);
          if(data.statusCode === 200 && data.body){
            dispatch({ type: GET_USER_TOS_SESSION_INFO_SUCCESS, payload: {data: data.body}});
          } else {
            dispatch({ type: GET_USER_TOS_SESSION_INFO_SUCCESS, payload: {data: null}});
          }
        }  
      }).catch((error: any) => {
        dispatch({ type: GET_USER_TOS_SESSION_INFO_SUCCESS, payload: {data: null}});
      })
      }
    } catch (error: any) {
      dispatch({ type: GET_USER_TOS_SESSION_INFO_FAILURE, payload: {data: null} });
    }
  };
};

export default {
  getTosSessionInfo,
};
